import { z } from "zod";

export const withEmailConfirmationValidation = <T extends z.ZodType>(
  schema: T
) =>
  schema.refine((data) => data.email === data.confirmEmail, {
    message: "Email addresses must match",
    path: ["confirmEmail"],
  });

export const personSchemaBaseFields = {
  firstName: z.string().min(1, "First Name is required"),
  lastName: z.string().min(1, "Last Name is required"),
  email: z.string().email("Invalid email address"),
  confirmEmail: z.string().email("Invalid email address"),
};

export const contactSchemaBaseFields = {
  ...personSchemaBaseFields,
  message: z.string(),
};

export const inviteInstitutionSchemaBaseFields = {
  ...personSchemaBaseFields,
  organization: z.string(),
};

export const profileSchemaBaseFields = {
  firstName: z.string().min(1, "First Name is required"),
  lastName: z.string().min(1, "Last Name is required"),
  photo: z.preprocess(
    (val) => (val == null ? undefined : val),
    z
      .object({
        file: z.string(),
        name: z.string(),
        size: z.number(),
        type: z.string(),
        original: z.any(),
      })
      .optional()
  ),
  pronouns: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val ?? undefined),
  website: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val ?? undefined),
  bio: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val ?? undefined),
  timezone: z.array(z.string()).min(1, "Timezone is required"),
  cv: z.preprocess(
    (val) => (val == null ? undefined : val),
    z
      .object({
        file: z.string(),
        name: z.string(),
        size: z.number(),
        type: z.string(),
        original: z.any(),
      })
      .optional()
  ),
  isEmailNotificationsEnabled: z.boolean().optional(),
};

export const accountSchemaBaseFields = {
  email: z.string().email("Invalid email address"),
  password: z
    .string()
    .min(
      8,
      "Enter your current password to confirm changing your email address."
    ),
};

export const supportSchemaBaseFields = {
  email: z.string().email("Invalid email address"),
  message: z.string().min(1, "Message is required"),
};

export const baseContactSchema = withEmailConfirmationValidation(
  z.object(contactSchemaBaseFields)
);

export const baseInviteSchema = withEmailConfirmationValidation(
  z.object(personSchemaBaseFields)
);

export const baseInviteInstitutionSchema = withEmailConfirmationValidation(
  z.object(inviteInstitutionSchemaBaseFields)
);

export const baseProfileSchema = z.object(profileSchemaBaseFields);

export const baseAccountSchema = z.object(accountSchemaBaseFields);

export const baseSupportSchema = z.object(supportSchemaBaseFields);
